import gameExpoWide from '../assets/gallery/dost/game_expo_2026_wide.jpeg';
import gameExpoTeam from '../assets/gallery/dost/game_expo_2026_team.jpeg';
import dostShowcase from '../assets/gallery/dost/740063405_2475444882976111_7108748801115591888_n.jpg';
import dostTeam from '../assets/gallery/dost/740611323_1269160891796150_3277609692194719083_n.jpeg';
import dostMoment from '../assets/gallery/dost/747111674_1035185445780443_1367414220676185968_n.jpg';
import campusFrame from '../assets/gallery/events/photo1.jpg';
import buildDay from '../assets/gallery/googleevent/photo2.jpeg';
import portraitStudy from '../assets/gallery/googleevent/photo3.jpeg';
import notebookRun from '../assets/gallery/events/photo4.jpeg';
import cityWalk from '../assets/gallery/events/photo5.jpeg';
import teamNotes from '../assets/gallery/googleevent/photo6.jpeg';
import ccsDayOne from '../assets/gallery/ccsdays/photo7.jpg';
import ccsDayTwo from '../assets/gallery/ccsdays/photo8.jpg';
import ccsDayThree from '../assets/gallery/ccsdays/photo9.jpg';
import eventMoment from '../assets/gallery/events/537139027_714212228328467_252878519283148253_n.jpg';

export const GALLERY_ALBUMS = [
  {
    id: 'dost',
    title: 'NEXT LEVEL: Esports Game Dev Challenge',
    eyebrow: 'Finalist · DOST 7',
    photos: [
      { src: gameExpoWide, title: 'NEXT Game Expo', alt: 'Game expo floor with attendees playing locally made games' },
      { src: gameExpoTeam, title: 'Tukyan booth', alt: 'Game developers and players at the expo booth' },
      { src: dostShowcase, title: 'Game showcase', fit: 'contain' },
      { src: dostTeam, title: 'Expo team' },
      { src: dostMoment, title: 'Expo moments', fit: 'contain' },
    ],
  },
  {
    id: 'ccs-days',
    title: 'CCS Days',
    eyebrow: 'University of Cebu',
    photos: [
      { src: ccsDayOne, title: 'CCS Days' },
      { src: ccsDayTwo, title: 'CCS Days moments' },
      { src: ccsDayThree, title: 'CCS Days team' },
    ],
  },
  {
    id: 'google-event',
    title: 'DevFest Cebu 2025',
    eyebrow: 'Google Developer Groups Cebu',
    photos: [
      { src: buildDay, title: 'Build day' },
      { src: portraitStudy, title: 'Portrait study' },
      { src: teamNotes, title: 'Team notes', fit: 'contain' },
    ],
  },
  {
    id: 'events',
    title: 'Campus & community events',
    eyebrow: 'More moments',
    photos: [
      { src: campusFrame, title: 'Campus frame' },
      { src: notebookRun, title: 'Notebook run' },
      { src: cityWalk, title: 'City walk' },
      { src: eventMoment, title: 'Event moments' },
    ],
  },
];

export const GALLERY_PHOTOS = GALLERY_ALBUMS.flatMap((album) => album.photos);
